import {QuoteItemV2} from 'api/magento/magentoAPI.schemas';

/**
 * get true if product has out of stock items
 */
export const getIsOutOfStock = (items?: QuoteItemV2[]) =>
    items?.some(item => Boolean(item.product.stock?.isOutOfStock));
